import React, { PureComponent, ReactElement } from 'react';

import { Image } from '@philips-emr/tws-components';
import { msg } from '@philips-emr/tws-core/lib/services';
import { isEmptyOrBlankString } from '@philips-emr/tws-utils';

import { DialogType } from '../dialog-service';

import { isDialogInformation } from './util-dialog-component';
import './dialog-header.scss';

interface DialogHeaderProps {

  title: string,

  type?: DialogType;

}

export default class DialogHeader extends PureComponent<DialogHeaderProps> {

  private renderImage(): ReactElement | null {
    if (!isDialogInformation(this.props.type)) {
      return null;
    }

    return (
      <Image className="c-dialog-header__title__cicle-outline--custom-size" alt="" src="/static/assets/DLS_InformationCircleOutline_24.svg" />
    );
  }

  public render(): ReactElement | null {
    const { title } = this.props;

    if (isEmptyOrBlankString(title)) {
      return null;
    }

    return (
      <div className="c-dialog-header">
        <div className="c-dialog-header__title">
          {this.renderImage()}
          {msg(title)}
        </div>
      </div>
    );
  }
}
